type JSConfetti = {
  addConfetti(): Promise<void>;
};

let instance: JSConfetti;

export async function launchConfetti() {
  if (!instance) {
    instance = new (await import("js-confetti")).default();
  }

  return instance.addConfetti();
}
